import axios from "axios";
import React, { useEffect, useState } from "react";
import apiUrl from "../../environment/Api";
import { useNavigate, useParams } from "react-router-dom";
import "../../assets/css/Addrole.css";

const allModules = [
  {
    name: "Dashboard",
    id: 1,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Roles",
    id: 2,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Users",
    id: 3,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Branch",
    id: 4,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Contact Leads",
    id: 5,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "New Enquiry",
    id: 6,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Enquiry",
    id: 7,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Followups",
    id: 8,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Funnel",
    id: 9,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Walkin-Details",
    id: 10,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Sourcetype",
    id: 11,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Enquirypurpose",
    id: 12,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Student Database",
    id: 13,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "PayType",
    id: 14,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Studying Students",
    id: 15,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Students Dairy",
    id: 16,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Completed",
    id: 17,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },

  {
    name: "Skill Development",
    id: 18,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Course",
    id: 19,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Category",
    id: 20,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },

  {
    name: "Schedule",
    id: 21,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Staff",
    id: 22,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Attendance",
    id: 23,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Designation",
    id: 24,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Leave",
    id: 25,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Travel Allowance",
    id: 26,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },

  {
    name: "Holiday",
    id: 27,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Salary Details",
    id: 28,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Event",
    id: 29,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Dailytask",
    id: 30,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Job Portal",
    id: 31,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Recruiting partner",
    id: 32,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "New Promotions",
    id: 33,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },

  {
    name: "Asset Type",
    id: 34,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Asset List",
    id: 35,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Expense Type",
    id: 36,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Expense List",
    id: 37,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "VendorDetails",
    id: 38,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Office Expense Type",
    id: 39,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },

  {
    name: "Income Type",
    id: 40,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Additional Income",
    id: 41,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Invoice",
    id: 42,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Daily Report",
    id: 43,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Enquiry Report",
    id: 44,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Attendance Report",
    id: 45,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Expense Report",
    id: 46,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Student Report",
    id: 47,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Staff Report",
    id: 48,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Income Report",
    id: 49,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
  {
    name: "Invoice Report",
    id: 50,
    actions: {
      all: false,
      add: false,
      edit: false,
      delete: false,
      view: false,
      download: false,
    },
  },
];

function Editrole() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [roleData, setRoleData] = useState({
    rolename: "",
    modules: allModules, // Fallback to allModules if API data is not fetched
  });

  // Fetch role data if we are editing an existing role
  useEffect(() => {
    const fetchData = async () => {
      if (id) {
        try {
          const response = await axios.get(`${apiUrl}/role_2/${id}`);
          console.log("Fetched data:", response.data); // Log the response
          const { rolename, modules } = response.data;

          // Check if rolename and modules are available
          if (rolename && Array.isArray(modules)) {
            const updatedModules = allModules.map((module) => {
              const foundModule = modules.find(
                (m) => String(m.id) === String(module.id)
              ); // Convert both IDs to strings
              if (foundModule) {
                return { ...module, actions: { ...foundModule.actions } };
              }
              return module;
            });

            setRoleData({ rolename, modules: updatedModules });
          } else {
            throw new Error("Invalid response format.");
          }
        } catch (error) {
          console.error("Error fetching role data:", error);
          alert("Error fetching role data. Please try again later.");
        }
      }
    };

    fetchData();
  }, [id]);

  // Handle input change for the role name
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setRoleData({ ...roleData, [name]: value });
  };

  // Handle checkbox changes for individual module actions or the "All" checkbox
  const handleCheckboxChange = (moduleId, action) => {
    setRoleData((prevRoleData) => {
      const updatedModules = prevRoleData.modules.map((module) => {
        if (module.id === moduleId) {
          if (action === "all") {
            const newActions = Object.keys(module.actions).reduce(
              (acc, key) => {
                acc[key] = !module.actions.all;
                return acc;
              },
              {}
            );
            return { ...module, actions: newActions };
          } else {
            return {
              ...module,
              actions: { ...module.actions, [action]: !module.actions[action] },
            };
          }
        }
        return module;
      });

      return { ...prevRoleData, modules: updatedModules };
    });
  };

  // Handle form submission (create or update role)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      let response;
      if (id) {
        // If we are editing an existing role, send a PUT request
        response = await axios.put(`${apiUrl}/role_2/${id}`, roleData);
      } else {
        // If creating a new role, send a POST request
        response = await axios.post(`${apiUrl}/role_2`, roleData);
      }

      if (response) {
        setRoleData({
          rolename: "",
          modules: allModules, // Reset to default modules after submission
        });
        navigate("/role");
      }
    } catch (err) {
      console.error("Error during submit:", err);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className="tops">
      <div className="admin-roles-main">
        {id ? <h5 className="text-start">Update Roles</h5> : <h4>Add Roles</h4>}
      </div>
      <div
        className="card p-3 mt-3"
        style={{ padding: "10px 10px", marginBottom: "20px" }}
      >
        <form onSubmit={handleSubmit}>
          <div className="row mt-2">
            <div className="form-label">
              <b>Designation :</b>
            </div>
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="Role Name"
                name="rolename"
                value={roleData.rolename}
                onChange={handleInputChange}
              />
            </div>

            <div className="mt-4">
              <div className="card-container table-responsive">
                <table className="admin-role-card">
                  <thead>
                    <tr className="text-center">
                      <th colSpan="7">Privileges</th>
                    </tr>
                    <tr className="text-center">
                      <th>Module</th>
                      <th>All</th>
                      <th>Add</th>
                      <th>Edit</th>
                      <th>Delete</th>
                      <th>View</th>
                      <th>Download</th>
                    </tr>
                  </thead>
                  <tbody>
                    {roleData.modules.map((module) => (
                      <tr className="text-start" key={module.id}>
                        <td className="role-data-name">{module.name}</td>
                        <td className="role-data-all">
                          <input
                            type="checkbox"
                            checked={module.actions.all}
                            onChange={() =>
                              handleCheckboxChange(module.id, "all")
                            }
                          />
                        </td>
                        <td className="role-data-add">
                          <input
                            type="checkbox"
                            checked={module.actions.add}
                            onChange={() =>
                              handleCheckboxChange(module.id, "add")
                            }
                          />
                        </td>
                        <td className="role-data-edit">
                          <input
                            type="checkbox"
                            checked={module.actions.edit}
                            onChange={() =>
                              handleCheckboxChange(module.id, "edit")
                            }
                          />
                        </td>
                        <td className="role-data-delete">
                          <input
                            type="checkbox"
                            checked={module.actions.delete}
                            onChange={() =>
                              handleCheckboxChange(module.id, "delete")
                            }
                          />
                        </td>
                        <td className="role-data-view">
                          <input
                            type="checkbox"
                            checked={module.actions.view}
                            onChange={() =>
                              handleCheckboxChange(module.id, "view")
                            }
                          />
                        </td>
                        <td className="role-data-download">
                          <input
                            type="checkbox"
                            checked={module.actions.download}
                            onChange={() =>
                              handleCheckboxChange(module.id, "download")
                            }
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-center mt-3">
            <button
              className="btn"
              onClick={() => navigate("/role")}
              style={{ background: "#ffc107",color:"white" }}
            >
              Back
            </button>
            <button type="submit" className="btn btn-info mx-4" style={{ background: "#b50707",color:"white",borderColor:"#8f0505" }}>
              {id ? "Update" : "Submit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Editrole;
